import { reactive } from 'vue'
import { useReceipts } from '@/services/receiptsOsaka/useReceipts'
import { useDialog } from '@/services/useDialog'

const receiptDialog = reactive({
  isPreview: false,
  isPreviewEnabled: false,
  isPreviewRegistered: false,
  isPreviewWaiting: false,
  isOffice: false,
})

const { openDialog } = useDialog()

export const useReceiptDialog = () => {
  const { setCurrentReceipt } = useReceipts()
  const openReceiptDialog = async receiptId => {
    await setCurrentReceipt(receiptId)

    receiptDialog.isPreview = false
    receiptDialog.isPreviewWaiting = false
    receiptDialog.isOffice = false
    openDialog('receipt')
  }

  const showPreview = isShown => {
    receiptDialog.isPreview = isShown
    receiptDialog.isPreviewRegistered = isShown
    receiptDialog.isOffice = isShown
  }
  const showForm = isShown => {
    receiptDialog.isPreview = isShown
    receiptDialog.isPreviewRegistered = isShown
    receiptDialog.isPreviewWaiting = isShown
  }

  return {
    receiptDialog,
    showPreview,
    showForm,
    openReceiptDialog,
  }
}
